import { CmsEntities } from './cmsConstants';

export const getCmsData = (cmsType: CmsEntities) => (state: any) => state.getIn(['app', 'cms', cmsType, 'data']);
